export interface OfflineRadio {
  id: number;
  name: string;
  slug: string;
  frequency: string;
  city: string;
  state: string;
  category: string;
  logoUrl: string;
  description: string;
  lastLiveAt: string;
  followers: number;
  totalPhotos: number;
  totalEvents: number;
  offlineReason: string;
}

export interface SimilarRadio {
  id: number;
  name: string;
  frequency: string;
  category: string;
  listeners: number;
  isLive: boolean;
  logoUrl: string;
}

export const offlineRadio: OfflineRadio = {
  id: 101,
  name: 'Radio Retro Vibes',
  slug: 'radio-retro-vibes',
  frequency: '96.30 RFW',
  city: 'Austin',
  state: 'Texas',
  category: 'Retro & Clásicos',
  logoUrl: 'https://readdy.ai/api/search-image?query=Retro%20classic%20radio%20station%20circular%20logo%20design%2C%20vintage%20microphone%20and%20vinyl%20record%20elements%2C%20warm%20amber%20gold%20and%20cream%20colors%2C%20clean%20modern%20minimalist%20emblem%2C%20nostalgic%20broadcast%20aesthetic%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20style&width=200&height=200&seq=offline-radio-logo&orientation=squarish',
  description: 'Reviviendo los grandes clásicos de los 80s y 90s. Música retro, entrevistas vintage y la mejor onda old school transmitiendo desde Austin, Texas.',
  lastLiveAt: '2026-06-07T14:30:00Z',
  followers: 3420,
  totalPhotos: 86,
  totalEvents: 14,
  offlineReason: 'Mantenimiento programado del servidor de streaming.',
};

export const similarRadios: SimilarRadio[] = [
  {
    id: 201,
    name: 'Clásicos del Rock',
    frequency: '95.10 RFW',
    category: 'Rock Clásico',
    listeners: 4892,
    isLive: true,
    logoUrl: 'https://readdy.ai/api/search-image?query=Classic%20rock%20radio%20station%20circular%20logo%20design%2C%20electric%20guitar%20and%20vinyl%20turntable%20elements%2C%20warm%20dark%20red%20and%20cream%20colors%2C%20vintage%20rock%20broadcast%20emblem%2C%20clean%20modern%20minimalist%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=similar-radio-1&orientation=squarish',
  },
  {
    id: 202,
    name: 'Ochentas FM',
    frequency: '102.70 RFW',
    category: '80s',
    listeners: 3150,
    isLive: true,
    logoUrl: 'https://readdy.ai/api/search-image?query=Eighties%20music%20radio%20station%20logo%2C%20retro%20cassette%20tape%20and%20neon%20elements%2C%20pink%20and%20cyan%20synthwave%20colors%2C%20circular%20modern%20emblem%2C%20nostalgic%2080s%20broadcast%20aesthetic%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=similar-radio-2&orientation=squarish',
  },
  {
    id: 203,
    name: 'Radio Vinilo Vintage',
    frequency: '88.50 RFW',
    category: 'Vinyl Classics',
    listeners: 2780,
    isLive: true,
    logoUrl: 'https://readdy.ai/api/search-image?query=Vinyl%20record%20radio%20station%20circular%20logo%20design%2C%20turntable%20and%20vinyl%20groove%20elements%2C%20warm%20sepia%20brown%20and%20cream%20colors%2C%20classic%20analog%20broadcast%20emblem%2C%20clean%20modern%20minimalist%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=similar-radio-3&orientation=squarish',
  },
  {
    id: 204,
    name: 'Radio Época Dorada',
    frequency: '91.40 RFW',
    category: 'Oldies',
    listeners: 1920,
    isLive: true,
    logoUrl: 'https://readdy.ai/api/search-image?query=Golden%20oldies%20radio%20station%20logo%2C%20vintage%20jukebox%20and%20musical%20notes%2C%20warm%20golden%20yellow%20and%20brown%20colors%2C%20circular%20nostalgic%20broadcast%20emblem%2C%20clean%20modern%20design%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20style&width=200&height=200&seq=similar-radio-4&orientation=squarish',
  },
  {
    id: 205,
    name: 'Rock & Roll Forever',
    frequency: '97.80 RFW',
    category: 'Rock & Roll',
    listeners: 5630,
    isLive: true,
    logoUrl: 'https://readdy.ai/api/search-image?query=Rock%20and%20roll%20radio%20station%20circular%20logo%2C%20vintage%20radio%20microphone%20and%20musical%20notes%2C%20black%20red%20and%20white%20color%20scheme%2C%20classic%20broadcast%20emblem%2C%20clean%20modern%20minimalist%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=similar-radio-5&orientation=squarish',
  },
  {
    id: 206,
    name: 'Soul & Funk Radio',
    frequency: '104.20 RFW',
    category: 'Soul & Funk',
    listeners: 2340,
    isLive: true,
    logoUrl: 'https://readdy.ai/api/search-image?query=Soul%20and%20funk%20radio%20station%20logo%2C%20vintage%20soul%20singer%20silhouette%20and%20vinyl%20elements%2C%20warm%20orange%20purple%20and%20cream%20colors%2C%20circular%20modern%20emblem%2C%20groovy%20broadcast%20aesthetic%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=similar-radio-6&orientation=squarish',
  },
];